class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    if(this._dhaScrollHandler) window.removeEventListener("scroll",this._dhaScrollHandler);
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = window.scrollY;
    this._dhaScrollHandler = () => {
      const currentScroll = Math.max(0,window.scrollY);
      if (window.innerWidth < 1024 && this.stickyHeader === 'on_scroll_up') {
        const delta = currentScroll - lastScroll;
        if (currentScroll <= extraSpace) {
          this.classList.remove(this.classes.scrollUp, this.classes.scrollDown, this.classes.stuck, this.classes.always, 'dha-sticky-arming');
          document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
          lastScroll = currentScroll;
          return;
        }
        // Let the original header leave naturally before positioning it offscreen.
        if (!this.classList.contains(this.classes.stuck)) {
          if (currentScroll <= this.headerHeight + extraSpace) {
            lastScroll = currentScroll;
            return;
          }
          this.classList.add('dha-sticky-arming', this.classes.stuck, this.classes.scrollDown);
          this.classList.remove(this.classes.scrollUp);
          document.body.classList.add(this.classes.headerScrollDown);
          document.body.classList.remove(this.classes.headerScrollUp);
          requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('dha-sticky-arming')));
        } else if (Math.abs(delta) >= 3) {
          const up = delta < 0;
          this.classList.toggle(this.classes.scrollUp, up);
          this.classList.toggle(this.classes.scrollDown, !up);
          document.body.classList.toggle(this.classes.headerScrollUp, up);
          document.body.classList.toggle(this.classes.headerScrollDown, !up);
        }
        if (Math.abs(delta) >= 3) lastScroll = currentScroll;
        return;
      }

      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    };
    window.addEventListener("scroll",this._dhaScrollHandler,{passive:true});
  }
}
customElements.define("m-header", MHeader);

